import React, {useCallback, useMemo} from 'react';
import {useLang} from "../../context/LanguageContext";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import useSubscriptions from "../../hooks/useSubscriptions";
import SubscriptionCard from "../../components/SubscriptionCard";
import Loading from "../../components/Loading";
import {FaArrowLeft} from "react-icons/fa";
import {loadStripe} from "@stripe/stripe-js";
import {EmbeddedCheckoutProvider, EmbeddedCheckout} from "@stripe/react-stripe-js";
import Api from "../../utils/Api";
import {useAuth} from "../../context/AuthContext";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const BuySubscriptionPage = () => {
    const { t } = useLang();
    const { id } = useParams();
    const subscriptions = useSubscriptions();
    const [subscription, setSubscription] = useState(null)
    const navigate = useNavigate();
    const { currentUser, customerId, checkPaymentExists } = useAuth();

    useEffect(() => {
        const subscriptionChosen = subscriptions.find(sub => sub.id === id);
        if(subscriptionChosen){
            setSubscription(subscriptionChosen);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, subscriptions]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (subscription === null) {
                navigate('/')
            }
        }, 5000);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscription]);

    // plata necesita cont: fara user logat mergem la pagina de cont
    useEffect(() => {
        if (!currentUser) {
            navigate('/account');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser]);

    const fetchClientSecret = useCallback(async () => {
        const data = await Api.createCheckoutSession(subscription.priceId, customerId);
        return data.clientSecret;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscription, customerId]);

    const handleComplete = useCallback(async () => {
        alert(t('txt.paymentSuccessfully'));
        await checkPaymentExists();
        navigate('/');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkoutOptions = useMemo(() => ({
        fetchClientSecret,
        onComplete: handleComplete,
    }), [fetchClientSecret, handleComplete]);

    if(!subscription || !currentUser || !customerId){
        return (
            <div className="relative min-h-screen bg-[#34495e] p-5">
                <Loading />
            </div>
        )
    }

    return (
        <div className="relative min-h-screen bg-[#34495e] p-5">
            <button
                onClick={() => navigate(-1)}
                className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
            >
                <FaArrowLeft/>
                <span className="text-white">{t('btn.back')}</span>
            </button>

            <div className="max-w-[700px] mx-auto space-y-6 mt-16">
                <SubscriptionCard sub={subscription} showBuy={false}/>
            </div>

            <div className="max-w-[700px] mx-auto mt-8 bg-white rounded-xl p-3 lg:p-6">
                <div className="font-bold text-center mb-4">
                    <span className="text-red-600 text-[15px] lg:text-[19px]">
                        {t('subs.paymentHint')}
                    </span>
                    <br />
                    <span className="text-[11px] lg:text-[15px]">
                        {t('txt.thanks')}
                    </span>
                </div>
                <EmbeddedCheckoutProvider stripe={stripePromise} options={checkoutOptions}>
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            </div>
        </div>
    )
}

export default BuySubscriptionPage;
